import { httpRequest } from "@services/http";

export interface CopyJourneyStepsPayload {
  // Source steps to clone; each is copied with its subtree.
  source_step_ids: number[];
  // Container the copies land in (a phase/step id), or null for the journey root.
  target_parent_id: number | null;
  // Levels to copy per node (1 = node only, 2 = + children, ...).
  depth?: number;
}

export class CommandCopyJourneySteps {
  async run(journeyId: number, payload: CopyJourneyStepsPayload) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/journeys/${journeyId}/steps/copy/`;
    return await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
}
